import { render } from "./UserProfileForm.vue?vue&type=template&id=a4dd5230"
import script from "./UserProfileForm.vue?vue&type=script&lang=js"
export * from "./UserProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__